import { SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { IObject } from "@quest/adapter-interface";

export let gameConstants: IObject = {
  GAME_CONTAINER_DIV: "gameContainer",

  SOUND_LIST_POSTLOAD: "soundList_1",
  SOUND_LIST_PRELOAD: "soundList",
  HelpPage: "HelpPage",

  //sound volume levels
  SOUND_VOL_POINT_3: 0.3,
  SOUND_VOL_POINT_4: 0.4,
  SOUND_VOL_1: 1,
  SCATTER_SYM_NUM: 12,
  WILD_STACK_SYM_NUM: 14,
  TRANSPARENT_SYM_NUM: 13,
  SPECIAL_SYM_NUM: 11,
  SPECIAL_DISABLE_SYM_NUM: 15,

  VOICE_OVER_VOLUME: 1,
  MUSIC_SPIN_VOLUME: 1,
  MUSIC_SPIN_FG_VOLUME: 1,
  // blur bg
  FULLSCREEN_BIGWIN_BG: "FULLSCREEN_BIGWIN_BG",
  FREEGAME_INTRO_BG: "FREEGAME_INTRO_BG",
  FREEGAME_OUTRO_BG: "FREEGAME_OUTRO_BG",
  SELECTION_BG: "SELECTION_BG",

  DISPLAY_BLOCK: "block",
  DISPLAY_NONE: "none",

  //scateer symbol anticipation
  FADED_SYMBOL: 0x363636,
  UNFADED_SYMBOL: 0xffffff,

  FREEGAME_RETURN_SOUND: false,

  BUTTON_PANEL_BG_ALPHA: 0.6,
  REEL_BOTTOM_SPACE: 0,
  IPAD_MINI_ASPECT_RATIO: 1.52,
  REEL_BOTTOM_SPACE_LANDSCAPE: 0,
  IPAD_PRO_ASPECT_RATIO: 10 / 7,

  REEL_PANEL_CONTAINER_POSITION: 32,
  LOGO_EXTRA_SCALE: 1.3,
  EXTRA_SPACE: 0,
  BSPOT_LANG: "bs",
  CREDIT_CONVERSION: 100,
  SYMBOL_ID_LIST: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 111],
  OFAKIND_PAYOUT_ID: ["symbol-payout-5", "symbol-payout-4", "symbol-payout-3"],
  WILD_EXTRA_ID: 111,
  WILD_ID: 0
};

(SlotConstantsBehavior.WrapperTopBarHeightDesktop = 32), (SlotConstantsBehavior.ADD_IN_Y = 90);
SlotConstantsBehavior.FONT_LIST = ["Arial", "ArialBlack", "MinionPro-Bold", "MinionProBoldIt", "ArialBold", "GODOFWAR"];
(SlotConstantsBehavior.GAME_NAME = "Legend of the Fire"), (SlotConstantsBehavior.VIEW_SLIDE_DESKTOP = 0);
SlotConstantsBehavior.setDelayForSpaghettiDispaly = 2000;
SlotConstantsBehavior.VIEW_SLIDE_MOBILE = 3;
SlotConstantsBehavior.SCALE_PERCENT_MOBILE = 1.17;
SlotConstantsBehavior.SCALE_PERCENT = 1;
SlotConstantsBehavior.BASEGAME_IDLE_SPINE = "basegame_idle_desktop";
SlotConstantsBehavior.FREEGAME_IDLE_SPINE = "freegame_idle_desktop";
